/**
 * Setup or destroy the accordion display of a select element
 * @param accordion Select element to transform
 * @param value Boolean set at true to setup the accordion, false to destroy it
 */
export function setAccordionState(accordion, value) {
    if (value) {
        accordion.classList.add('accordion-select');
    } else {
        accordion.classList.remove('accordion-select');
    }
    setAccordionDisplay(accordion, !value);
}

/**
 * Open or close an accordion
 * @param accordion HTML Element in question
 * @param value Boolean set at true to open the accordion, false to close it
 */
export function setAccordionDisplay(accordion, value) {
    const accordionTrigger = accordion.querySelector('.custom-select__trigger');
    const accordionContent = accordion.querySelector('.custom-options');
    if (value) {
        accordionTrigger.classList.add('active');
    } else {
        accordionTrigger.classList.remove('active');
    }
    accordionContent.style.display = value ? "block" : "none";
    accordionContent.style.transform = value ? "scaleY(1)" : "scaleY(0)";
}

/**
 * Transform all the select in the page that have the data-accordion="true" attribute into accordions
 */
export function setupAccordions() {
    const accordions = document.querySelectorAll('.custom-select[data-accordion="true"]');
    accordions.forEach((accordion) => {
        setAccordionState(accordion, true);
        if (!accordion.dataset.loaded) {    //To prevent adding multiple event handlers when setting up multiple times
            accordion.addEventListener('click', (e) => {
                if (e.target.classList.contains('custom-option') || !accordion.classList.contains('accordion-select'))
                    return
                const accordionContent = accordion.querySelector('.custom-options');
                const accordionTrigger = accordion.querySelector('.custom-select__trigger');
                if (accordionTrigger.classList.toggle('active')) {
                    accordionContent.style.display = "block";
                    accordionContent.style.transform = "scaleY(1)";
                } else {
                    accordionContent.style.display = "none";
                    accordionContent.style.transform = "scaleY(0)";
                }
            });
            accordion.dataset.loaded = "true";
        }
    });
}

/**
 * Destroy all the accordions already setup in the page
 */
export function destroyAccordions() {
    const accordions = document.querySelectorAll('.custom-select[data-accordion="true"]');
    accordions.forEach((accordion) => {
        setAccordionState(accordion, false);
    });
}
